export const sortItems = (items, term) => {
    if (term === 'CHEAP') {
      return items.sort(function (a, b) {
        if (a.price > b.price) {
          return 1;
        }
        if (a.price < b.price) {
          return -1;
        }
        // a должно быть равным b
        return 0;
      });
    } else if (term === 'FAST') {
      return items.sort(function (a, b) {
        if (a.segments[0].duration + a.segments[1].duration > b.segments[0].duration + b.segments[1].duration) {
          return 1;
        }
        if (a.segments[0].duration + a.segments[1].duration < b.segments[0].duration + b.segments[1].duration) {
          return -1;
        }
        // a должно быть равным b
        return 0;
      });
    }
  }